export default "__VITE_ASSET__BDJJ$4nn__"